$wj([48],{

/***/ 1546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var reactive_1 = __webpack_require__(1593);
exports.reactive = reactive_1.default;


/***/ }),

/***/ 1593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var globalContext_1 = __webpack_require__(60);
var mobx_react_1 = __webpack_require__(11);
function setPropAccessors(props, selector) {
    var newProps = {};
    Object.keys(props).forEach(function (key) {
        newProps[key] = props[key];
    });
    Object.keys(selector).forEach(function (key) {
        var getter = selector[key];
        if (typeof newProps[key] === typeof undefined) {
            Object.defineProperty(newProps, key, {
                enumerable: true,
                get: function () { return getter.call(null, newProps); },
            });
        }
    });
    return newProps;
}
function createNewConstructor(original, selector) {
    if (!selector) {
        return original;
    }
    return (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            return React.createElement(original, setPropAccessors(this.props, selector));
        };
        return class_1;
    }(React.Component));
}
function createNewFunctionalComponent(original, selector) {
    if (!selector) {
        return original;
    }
    return function (props) {
        var newProps = setPropAccessors(props, selector);
        return original.call(original, newProps);
    };
}
function isReactComponent(target) {
    return target && target.prototype && target.prototype.isReactComponent;
}
function isFunction(target) {
    return target instanceof Function;
}
function reactive(selectorOrComponentClass) {
    if (isReactComponent(selectorOrComponentClass)) {
        var componentClass = selectorOrComponentClass;
        return mobx_react_1.observer(componentClass);
    }
    return function (target) {
        if (globalContext_1.getGlobalContext().legacyTestMode) {
            if (isReactComponent(target)) {
                return mobx_react_1.observer(target);
            }
            else if (isFunction(target)) {
                return mobx_react_1.observer(target);
            }
            return target;
        }
        var newComponent;
        if (isReactComponent(target)) {
            newComponent = mobx_react_1.observer(createNewConstructor(mobx_react_1.observer(target), selectorOrComponentClass));
            newComponent.nonReactiveComponent = target;
            return newComponent;
        }
        else if (isFunction(target)) {
            newComponent = mobx_react_1.observer(createNewFunctionalComponent(target, selectorOrComponentClass));
            newComponent.nonReactiveStatelessComponent = target;
            return newComponent;
        }
        return newComponent;
    };
}
exports.default = reactive;


/***/ }),

/***/ 2341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var loadCalendarEvents_1 = __webpack_require__(4813);
exports.loadCalendarEvents = loadCalendarEvents_1.default;
var loadWeatherForecast_1 = __webpack_require__(4818);
exports.loadWeatherForecast = loadWeatherForecast_1.default;
var UpNext_1 = __webpack_require__(4823);
exports.UpNext = UpNext_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2594:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "../resources/images/weather_sprite.png";

/***/ }),

/***/ 2935:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = __webpack_require__(2);
var mobx_1 = __webpack_require__(15);
exports.default = satcheljs_1.createStore('upNextViewState', {
    calendarItems: mobx_1.map(),
    isAgendaOpen: false,
    isExpansionOpen: false,
    weatherClickThrough: '',
    weatherDailyConditions: [],
})();
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 3342:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(3343);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 3343:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] ._2czud94MRy5EIlV6GwOhnh{background-image:url(" + __webpack_require__(2594) + ");background-position:-33px 0;width:32px;height:20px}html[dir] .KJY13tySrP_c6Vd9icmzE{background-image:url(" + __webpack_require__(2594) + ");background-position:-165px -42px;width:32px;height:20px}html[dir] ._3K5-AFhJ4keHz2UXOvSQJ0{background-image:url(" + __webpack_require__(2594) + ");background-position:0 -21px;width:32px;height:20px}html[dir] ._2ZBJy72t6GYvJ_nhZOblo4{background-image:url(" + __webpack_require__(2594) + ");background-position:-33px -21px;width:32px;height:20px}html[dir] ._3vkcIE6EV4fZEv9sY0S-Xy{background-image:url(" + __webpack_require__(2594) + ");background-position:0 -42px;width:32px;height:20px}html[dir] ._1EqUjvmne4rYHmqq2oxEpD{background-image:url(" + __webpack_require__(2594) + ");background-position:-33px -42px;width:32px;height:20px}html[dir] ._2ro_Jww9XUF4uwwAnad9nT{background-image:url(" + __webpack_require__(2594) + ");background-position:-66px 0;width:32px;height:20px}html[dir] ._2p8hAutTEM7EtVjD1EY8Z1{background-image:url(" + __webpack_require__(2594) + ");background-position:-66px -21px;width:32px;height:20px}html[dir] ._2VIWlulrRAPQHu4FxIpVm8{background-image:url(" + __webpack_require__(2594) + ");background-position:-66px -42px;width:32px;height:20px}html[dir] ._3tjUMoeY8HDcYvyG9MRamL{background-image:url(" + __webpack_require__(2594) + ");background-position:0 -63px;width:32px;height:20px}html[dir] .MHSHKbGbxXZHO3CL9ucm2{background-image:url(" + __webpack_require__(2594) + ");background-position:-33px -63px;width:32px;height:20px}html[dir] ._2811nzJty6ArkuwtOb1qTS{background-image:url(" + __webpack_require__(2594) + ");background-position:-66px -63px;width:32px;height:20px}html[dir] ._1W3jIru-aLIUOKGCdjG2J2{background-image:url(" + __webpack_require__(2594) + ");background-position:-99px 0;width:32px;height:20px}html[dir] ._3FkYXdUJvTyPlriEjgpgR8{background-image:url(" + __webpack_require__(2594) + ");background-position:-99px -21px;width:32px;height:20px}html[dir] .xFw8eo8heF8s-NnZKxbzw{background-image:url(" + __webpack_require__(2594) + ");background-position:-99px -42px;width:32px;height:20px}html[dir] ._3PLzjtfGr14pR1rm94tAl8{background-image:url(" + __webpack_require__(2594) + ");background-position:-99px -63px;width:32px;height:20px}html[dir] ._14cvR7damBUQZ9Z4nyYTuC{background-image:url(" + __webpack_require__(2594) + ");background-position:0 -84px;width:32px;height:20px}html[dir] ._2L5JMl1FGhc9VDCJ-oucC2{background-image:url(" + __webpack_require__(2594) + ");background-position:-33px -84px;width:32px;height:20px}html[dir] ._2WENLK_3FHQskBs3gzBVEt{background-image:url(" + __webpack_require__(2594) + ");background-position:-66px -84px;width:32px;height:20px}html[dir] ._2X1MUdKnPOrHxHT2iWWJel{background-image:url(" + __webpack_require__(2594) + ");background-position:-99px -84px;width:32px;height:20px}html[dir] ._2GRx1hDjgW6I8Pc42INoUB{background-image:url(" + __webpack_require__(2594) + ");background-position:0 -105px;width:32px;height:20px}html[dir] ._24BX_1nT_SU_17yeOt4zb5{background-image:url(" + __webpack_require__(2594) + ");background-position:-33px -105px;width:32px;height:20px}html[dir] ._379BiO6kS8V3-AxXyasBUy{background-image:url(" + __webpack_require__(2594) + ");background-position:-66px -105px;width:32px;height:20px}html[dir] ._1EkEXnDDePyZtn7Et1X1Zm{background-image:url(" + __webpack_require__(2594) + ");background-position:-99px -105px;width:32px;height:20px}html[dir] ._3xku-iYWpOCRXtE4X8QRZL{background-image:url(" + __webpack_require__(2594) + ");background-position:-132px 0;width:32px;height:20px}html[dir] ._26Ns7DxCRf0j7RI7L9gVgX{background-image:url(" + __webpack_require__(2594) + ");background-position:-132px -21px;width:32px;height:20px}html[dir] .U2yBqeflnolzb_bMZK1gv{background-image:url(" + __webpack_require__(2594) + ");background-position:-132px -42px;width:32px;height:20px}html[dir] ._2CiDJDSivOhxt387qrpSmw{background-image:url(" + __webpack_require__(2594) + ");background-position:-132px -63px;width:32px;height:20px}html[dir] ._1WgKqfLr615I4s4ZCBCX0j{background-image:url(" + __webpack_require__(2594) + ");background-position:-132px -84px;width:32px;height:20px}html[dir] ._2hvYrjQS0xXM9WuppRFJb8{background-image:url(" + __webpack_require__(2594) + ");background-position:-132px -105px;width:32px;height:20px}html[dir] ._3pAbCs0-0pC_SwiapdkVjN{background-image:url(" + __webpack_require__(2594) + ");background-position:0 -126px;width:32px;height:20px}html[dir] .GKp0xdcWWhFrL9gaXZc9x{background-image:url(" + __webpack_require__(2594) + ");background-position:-33px -126px;width:32px;height:20px}html[dir] ._2htMmPG0KC3grNsXvZccVB{background-image:url(" + __webpack_require__(2594) + ");background-position:-66px -126px;width:32px;height:20px}html[dir] ._2rTAiif9xK6n1RsSwyr8V7{background-image:url(" + __webpack_require__(2594) + ");background-position:-99px -126px;width:32px;height:20px}html[dir] ._1uI5amnv5yGWMdP4zT8KjW{background-image:url(" + __webpack_require__(2594) + ");background-position:-132px -126px;width:32px;height:20px}html[dir] ._1R55B3AGBKxnAtDMlV-TBw{background-image:url(" + __webpack_require__(2594) + ");background-position:-165px 0;width:32px;height:20px}html[dir] ._1lzgkzculCeBXiM9KYVNRJ{background-image:url(" + __webpack_require__(2594) + ");background-position:-165px -21px;width:32px;height:20px}html[dir] ._3EOdIx9QPZTyqJCY6oDPXJ{background-image:url(" + __webpack_require__(2594) + ");background-position:0 0;width:32px;height:20px}html[dir] .CNMtzP5VzTxfAXEfWbkJ_{background-image:url(" + __webpack_require__(2594) + ");background-position:-165px -63px;width:32px;height:20px}html[dir] ._327p2-DmkRMBlAld0KBWa9{background-image:url(" + __webpack_require__(2594) + ");background-position:-165px -84px;width:32px;height:20px}html[dir] ._1HmqO-n3XXFFB2CFHLpfeh{background-image:url(" + __webpack_require__(2594) + ");background-position:-165px -105px;width:32px;height:20px}html[dir] ._2Sz5O0XKlQNEreEFY6KtAR{background-image:url(" + __webpack_require__(2594) + ");background-position:-165px -126px;width:32px;height:20px}html[dir] ._2BS-Ex_yhni8AtN3EwzSHu{background-image:url(" + __webpack_require__(2594) + ");background-position:0 -147px;width:32px;height:20px}html[dir] ._1miFkpX_Y-VaEHj0NOGmSt{background-image:url(" + __webpack_require__(2594) + ");background-position:-33px -147px;width:32px;height:20px}html[dir] .g_6dB1sVfO139tPQuhv0k{background-image:url(" + __webpack_require__(2594) + ");background-position:-66px -147px;width:32px;height:20px}html[dir] ._1jTXnMw-1mRy4Ib-YU_SPp{background-image:url(" + __webpack_require__(2594) + ");background-position:-99px -147px;width:32px;height:20px}html[dir] .QowJq3eHdu6QpVD2zcLci{background-image:url(" + __webpack_require__(2594) + ");background-position:-132px -147px;width:32px;height:20px}html[dir] ._3ApUtOCnt6LyNSWPWICGcz{background-image:url(" + __webpack_require__(2594) + ");background-position:-165px -147px;width:32px;height:20px}html[dir] ._1iueKbdYB4KQeQinmBAABK{background-image:url(" + __webpack_require__(2594) + ");background-position:0 -168px;width:32px;height:20px}html[dir] .Lf0ITOgxwHwPd4LqPX0v5{background-image:url(" + __webpack_require__(2594) + ");background-position:-33px -168px;width:32px;height:20px}html[dir] ._1gQGhmpvWOpSpDynOy_218{background-image:url(" + __webpack_require__(2594) + ");background-position:-66px -168px;width:32px;height:20px}html[dir] ._2Jsb8KDhrSmEErbb-Z8o7U{background-image:url(" + __webpack_require__(2594) + ");background-position:-99px -168px;width:32px;height:20px}html[dir] .lcyq6tZD1bsklJdnPk1vf{background-image:url(" + __webpack_require__(2594) + ");background-position:-132px -168px;width:32px;height:20px}html[dir] ._1PFHANe3VBFHK6VeQFL0Af{background-image:url(" + __webpack_require__(2594) + ");background-position:-165px -168px;width:32px;height:20px}html[dir] .gHh5fyMcipAu83zvz9dQD{background-image:url(" + __webpack_require__(2594) + ");background-position:-198px 0;width:32px;height:20px}html[dir] .qM84XKHlkgJiPUHR3fDJS{background-image:url(" + __webpack_require__(2594) + ");background-position:-198px -21px;width:32px;height:20px}html[dir] .YvLfTQRvVG4YICm52cDm3{background-image:url(" + __webpack_require__(2594) + ");background-position:-198px -42px;width:32px;height:20px}html[dir] ._25dqUXOtZlAMRB7Tnamxll{background-image:url(" + __webpack_require__(2594) + ");background-position:-198px -63px;width:32px;height:20px}html[dir] .WjkaJfEDc8CC0vK1GJiGj{background-image:url(" + __webpack_require__(2594) + ");background-position:-198px -84px;width:32px;height:20px}html[dir] ._2bCQDKgJokQcg76DT7g4Zt{background-image:url(" + __webpack_require__(2594) + ");background-position:-198px -105px;width:32px;height:20px}html[dir] ._1mktv93QllXs1dtRO_XYcE{background-image:url(" + __webpack_require__(2594) + ");background-position:-198px -126px;width:32px;height:20px}html[dir] ._3F0fE3gtMCmSwqVtpli19X{background-image:url(" + __webpack_require__(2594) + ");background-position:-198px -147px;width:32px;height:20px}html[dir] ._23Yu8KWv6GtXLSXz0nML-Q{background-image:url(" + __webpack_require__(2594) + ");background-position:-198px -168px;width:32px;height:20px}html[dir] ._30qZz_BHQFyLo1GG9g1g0w{background-image:url(" + __webpack_require__(2594) + ");background-position:0 -189px;width:32px;height:20px}html[dir] ._3fZhbSEG2OIU5KPBMmATh-{background-image:url(" + __webpack_require__(2594) + ");background-position:-33px -189px;width:32px;height:20px}html[dir] .SRUf3-CHWjpyvpv1D4iOF{background-image:url(" + __webpack_require__(2594) + ");background-position:-66px -189px;width:32px;height:20px}html[dir] ._1DShn0OCEPDNkH2IIQL1bn{background-image:url(" + __webpack_require__(2594) + ");background-position:-99px -189px;width:32px;height:20px}html[dir] ._2uSVcbWpetBSh3b01AKlrD{background-image:url(" + __webpack_require__(2594) + ");background-position:-132px -189px;width:32px;height:20px}html[dir] ._3qtAmYZrAvv79j_asNgpIU{background-image:url(" + __webpack_require__(2594) + ");background-position:-165px -189px;width:32px;height:20px}html[dir] ._2cIMGwCWTMy134ECsyp9hZ{background-image:url(" + __webpack_require__(2594) + ");background-position:-198px -189px;width:32px;height:20px}html[dir] ._163piJMJLL0InuQCPX9MS6{background-image:url(" + __webpack_require__(2594) + ");background-position:0 -210px;width:32px;height:20px}html[dir] ._30H2GvvB5uJEBz-fIMRTAa{background-image:url(" + __webpack_require__(2594) + ");background-position:-33px -210px;width:32px;height:20px}html[dir] .ogtNtCg9gvarFADZAfzNq{background-image:url(" + __webpack_require__(2594) + ");background-position:-66px -210px;width:32px;height:20px}html[dir] .m5uDz2H0FQc5TRHAIKlnh{background-image:url(" + __webpack_require__(2594) + ");background-position:-99px -210px;width:32px;height:20px}", ""]);

// exports
exports.locals = {
	"weather-icon-SkyCode_32pct_0": "_2czud94MRy5EIlV6GwOhnh",
	"weather-icon-SkyCode_32pct_10": "KJY13tySrP_c6Vd9icmzE",
	"weather-icon-SkyCode_32pct_11": "_3K5-AFhJ4keHz2UXOvSQJ0",
	"weather-icon-SkyCode_32pct_13": "_2ZBJy72t6GYvJ_nhZOblo4",
	"weather-icon-SkyCode_32pct_15": "_3vkcIE6EV4fZEv9sY0S-Xy",
	"weather-icon-SkyCode_32pct_16": "_1EqUjvmne4rYHmqq2oxEpD",
	"weather-icon-SkyCode_32pct_18": "_2ro_Jww9XUF4uwwAnad9nT",
	"weather-icon-SkyCode_32pct_19": "_2p8hAutTEM7EtVjD1EY8Z1",
	"weather-icon-SkyCode_32pct_20": "_2VIWlulrRAPQHu4FxIpVm8",
	"weather-icon-SkyCode_32pct_21": "_3tjUMoeY8HDcYvyG9MRamL",
	"weather-icon-SkyCode_32pct_22": "MHSHKbGbxXZHO3CL9ucm2",
	"weather-icon-SkyCode_32pct_23": "_2811nzJty6ArkuwtOb1qTS",
	"weather-icon-SkyCode_32pct_24": "_1W3jIru-aLIUOKGCdjG2J2",
	"weather-icon-SkyCode_32pct_25": "_3FkYXdUJvTyPlriEjgpgR8",
	"weather-icon-SkyCode_32pct_26": "xFw8eo8heF8s-NnZKxbzw",
	"weather-icon-SkyCode_32pct_27": "_3PLzjtfGr14pR1rm94tAl8",
	"weather-icon-SkyCode_32pct_28": "_14cvR7damBUQZ9Z4nyYTuC",
	"weather-icon-SkyCode_32pct_29": "_2L5JMl1FGhc9VDCJ-oucC2",
	"weather-icon-SkyCode_32pct_30": "_2WENLK_3FHQskBs3gzBVEt",
	"weather-icon-SkyCode_32pct_31": "_2X1MUdKnPOrHxHT2iWWJel",
	"weather-icon-SkyCode_32pct_32": "_2GRx1hDjgW6I8Pc42INoUB",
	"weather-icon-SkyCode_32pct_33": "_24BX_1nT_SU_17yeOt4zb5",
	"weather-icon-SkyCode_32pct_34": "_379BiO6kS8V3-AxXyasBUy",
	"weather-icon-SkyCode_32pct_36": "_1EkEXnDDePyZtn7Et1X1Zm",
	"weather-icon-SkyCode_32pct_37": "_3xku-iYWpOCRXtE4X8QRZL",
	"weather-icon-SkyCode_32pct_38": "_26Ns7DxCRf0j7RI7L9gVgX",
	"weather-icon-SkyCode_32pct_39": "U2yBqeflnolzb_bMZK1gv",
	"weather-icon-SkyCode_32pct_4": "_2CiDJDSivOhxt387qrpSmw",
	"weather-icon-SkyCode_32pct_41": "_1WgKqfLr615I4s4ZCBCX0j",
	"weather-icon-SkyCode_32pct_43": "_2hvYrjQS0xXM9WuppRFJb8",
	"weather-icon-SkyCode_32pct_44": "_3pAbCs0-0pC_SwiapdkVjN",
	"weather-icon-SkyCode_32pct_45": "GKp0xdcWWhFrL9gaXZc9x",
	"weather-icon-SkyCode_32pct_46": "_2htMmPG0KC3grNsXvZccVB",
	"weather-icon-SkyCode_32pct_47": "_2rTAiif9xK6n1RsSwyr8V7",
	"weather-icon-SkyCode_32pct_48": "_1uI5amnv5yGWMdP4zT8KjW",
	"weather-icon-SkyCode_32pct_49": "_1R55B3AGBKxnAtDMlV-TBw",
	"weather-icon-SkyCode_32pct_5": "_1lzgkzculCeBXiM9KYVNRJ",
	"weather-icon-SkyCode_32pct_50": "_3EOdIx9QPZTyqJCY6oDPXJ",
	"weather-icon-SkyCode_32pct_51": "CNMtzP5VzTxfAXEfWbkJ_",
	"weather-icon-SkyCode_32pct_52": "_327p2-DmkRMBlAld0KBWa9",
	"weather-icon-SkyCode_32pct_53": "_1HmqO-n3XXFFB2CFHLpfeh",
	"weather-icon-SkyCode_32pct_54": "_2Sz5O0XKlQNEreEFY6KtAR",
	"weather-icon-SkyCode_32pct_55": "_2BS-Ex_yhni8AtN3EwzSHu",
	"weather-icon-SkyCode_32pct_56": "_1miFkpX_Y-VaEHj0NOGmSt",
	"weather-icon-SkyCode_32pct_57": "g_6dB1sVfO139tPQuhv0k",
	"weather-icon-SkyCode_32pct_58": "_1jTXnMw-1mRy4Ib-YU_SPp",
	"weather-icon-SkyCode_32pct_59": "QowJq3eHdu6QpVD2zcLci",
	"weather-icon-SkyCode_32pct_6": "_3ApUtOCnt6LyNSWPWICGcz",
	"weather-icon-SkyCode_32pct_60": "_1iueKbdYB4KQeQinmBAABK",
	"weather-icon-SkyCode_32pct_61": "Lf0ITOgxwHwPd4LqPX0v5",
	"weather-icon-SkyCode_32pct_62": "_1gQGhmpvWOpSpDynOy_218",
	"weather-icon-SkyCode_32pct_63": "_2Jsb8KDhrSmEErbb-Z8o7U",
	"weather-icon-SkyCode_32pct_64": "lcyq6tZD1bsklJdnPk1vf",
	"weather-icon-SkyCode_32pct_65": "_1PFHANe3VBFHK6VeQFL0Af",
	"weather-icon-SkyCode_32pct_66": "gHh5fyMcipAu83zvz9dQD",
	"weather-icon-SkyCode_32pct_67": "qM84XKHlkgJiPUHR3fDJS",
	"weather-icon-SkyCode_32pct_68": "YvLfTQRvVG4YICm52cDm3",
	"weather-icon-SkyCode_32pct_69": "_25dqUXOtZlAMRB7Tnamxll",
	"weather-icon-SkyCode_32pct_7": "WjkaJfEDc8CC0vK1GJiGj",
	"weather-icon-SkyCode_32pct_70": "_2bCQDKgJokQcg76DT7g4Zt",
	"weather-icon-SkyCode_32pct_71": "_1mktv93QllXs1dtRO_XYcE",
	"weather-icon-SkyCode_32pct_72": "_3F0fE3gtMCmSwqVtpli19X",
	"weather-icon-SkyCode_32pct_73": "_23Yu8KWv6GtXLSXz0nML-Q",
	"weather-icon-SkyCode_32pct_74": "_30qZz_BHQFyLo1GG9g1g0w",
	"weather-icon-SkyCode_32pct_75": "_3fZhbSEG2OIU5KPBMmATh-",
	"weather-icon-SkyCode_32pct_76": "SRUf3-CHWjpyvpv1D4iOF",
	"weather-icon-SkyCode_32pct_77": "_1DShn0OCEPDNkH2IIQL1bn",
	"weather-icon-SkyCode_32pct_78": "_2uSVcbWpetBSh3b01AKlrD",
	"weather-icon-SkyCode_32pct_79": "_3qtAmYZrAvv79j_asNgpIU",
	"weather-icon-SkyCode_32pct_80": "_2cIMGwCWTMy134ECsyp9hZ",
	"weather-icon-SkyCode_32pct_81": "_163piJMJLL0InuQCPX9MS6",
	"weather-icon-SkyCode_32pct_82": "_30H2GvvB5uJEBz-fIMRTAa",
	"weather-icon-SkyCode_32pct_83": "ogtNtCg9gvarFADZAfzNq",
	"weather-icon-SkyCode_32pct_9": "m5uDz2H0FQc5TRHAIKlnh"
};

/***/ }),

/***/ 3676:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    loadCalendarEvents: { datapoint: { name: 'LoadCalendar' } },
    loadWeatherForecast: { datapoint: { name: 'WEATHER' } },
};
//# sourceMappingURL=datapoints.js.map

/***/ }),

/***/ 3677:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var owa_strings_1 = __webpack_require__(20);
var weatherSpriteStyles = __webpack_require__(3342);
// 0 is the fallback 'unknown' image.
function getWeatherImage(skyCodeId) {
    if (skyCodeId === void 0) { skyCodeId = 0; }
    skyCodeId = skyCodeId < 4 || skyCodeId > 83 ? 0 : skyCodeId; // Set the valid ranges.
    return weatherSpriteStyles[owa_strings_1.format('weather-icon-SkyCode_32pct_{0}', skyCodeId)];
}
exports.default = getWeatherImage;
//# sourceMappingURL=getWeatherImage.js.map

/***/ }),

/***/ 4813:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = __webpack_require__(3676);
var getCalendarViewService_1 = __webpack_require__(4814);
var store_1 = __webpack_require__(2935);
var legacy_1 = __webpack_require__(1);
var NUMBER_OF_DAYS_TO_LOAD = 2;
var addCalendarItemsToStore = legacy_1.action('addCalendarItemsToStore')(function addCalendarItemsToStore(calendarItems, items) {
    calendarItems.clear();
    if (items) {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            calendarItems.set(item.ItemId.Id, item);
        }
    }
});
exports.default = legacy_1.action('loadCalendarEvents', datapoints_1.default.loadCalendarEvents)(legacy_1.select({
    calendarItems: function () { return store_1.default.calendarItems; },
    today: function () { return new Date(); },
})(function loadCalendarEvents(state) {
    // 1 millisecond so we are really at the beginning of today.
    var today = state.today, calendarItems = state.calendarItems;
    today.setHours(0, 0, 0, 1);
    var queryStart = today;
    var queryEnd = new Date(today); // today + NUMBER_OF_DAYS_TO_LOAD
    queryEnd.setDate(queryStart.getDate() + NUMBER_OF_DAYS_TO_LOAD);
    // TODO: Task 538: Handle failure from the server call
    return getCalendarViewService_1.default(queryStart, queryEnd).then(function (items) {
        addCalendarItemsToStore(calendarItems, items);
    });
}));
//# sourceMappingURL=loadCalendarEvents.js.map

/***/ }),

/***/ 4814:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var folderId_1 = __webpack_require__(47);
/* tslint:disable:restrict-import-path */
var folderNameToId_1 = __webpack_require__(35);
/* tslint:enable:restrict-import-path */
var getCalendarViewOperation_1 = __webpack_require__(4815);
var getCalendarViewRequest_1 = __webpack_require__(4817);
var targetFolderId_1 = __webpack_require__(156);
var ServiceRequestUtils_1 = __webpack_require__(31);
function getCalendarViewService(rangeStart, rangeEnd) {
    // Example:
    // RangeStart: "2016-12-02T00:00:00.001",
    // RangeEnd: "2016-12-04T00:00:00.000"
    return getCalendarViewOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: getCalendarViewRequest_1.default({
            CalendarId: targetFolderId_1.default({
                BaseFolderId: folderId_1.default({
                    Id: folderNameToId_1.default('calendar'),
                }),
            }),
            RangeStart: rangeStart.toISOString(),
            RangeEnd: rangeEnd.toISOString(),
        }),
    }).then(function (response) {
        return response.Body.Items;
    });
}
exports.default = getCalendarViewService;
//# sourceMappingURL=getCalendarViewService.js.map

/***/ }),

/***/ 4815:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var getCalendarViewJsonRequest_1 = __webpack_require__(4816);
function getCalendarViewOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = getCalendarViewJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("GetCalendarView", req, options);
}
exports.default = getCalendarViewOperation;


/***/ }),

/***/ 4816:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getCalendarViewJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetCalendarViewJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = getCalendarViewJsonRequest;


/***/ }),

/***/ 4817:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getCalendarViewRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetCalendarViewRequest:#Exchange' }, data);
    return result;
}
exports.default = getCalendarViewRequest;


/***/ }),

/***/ 4818:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var datapoints_1 = __webpack_require__(3676);
var getUserConfiguration_1 = __webpack_require__(9);
var getWeatherForecastService_1 = __webpack_require__(4819);
var store_1 = __webpack_require__(2935);
var legacy_1 = __webpack_require__(1);
var addWeatherDailyConditionsToStore = legacy_1.action('addWeatherDailyConditionsToStore')(function addWeatherDailyConditionsToStore(weatherDailyConditions, weatherForecastResponse) {
    if (weatherDailyConditions && weatherForecastResponse) {
        // Clear array, instead of constructing a new one.
        weatherDailyConditions.length = 0;
        var currentLocation = weatherForecastResponse.WeatherLocations[0];
        weatherDailyConditions.push(currentLocation.Conditions); // Weather right now.
        store_1.default.weatherClickThrough = currentLocation.ClickThrough;
        currentLocation.MultidayForecast.DailyForecasts.forEach(function (item) {
            weatherDailyConditions.push(item); // Weather for the following days.
        });
    }
});
exports.default = legacy_1.action('loadWeatherForecast', datapoints_1.default.loadWeatherForecast)(legacy_1.select({
    weatherDailyConditions: function () { return store_1.default.weatherDailyConditions; },
    weatherLocations: function () { return getUserConfiguration_1.default().UserOptions.WeatherLocations; },
    weatherUnit: function () { return getUserConfiguration_1.default().UserOptions.WeatherUnit; },
})(function loadWeatherForecast(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var locations_1, weatherForecastResponse;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(state.weatherLocations && state.weatherLocations.length > 0)) return [3 /*break*/, 2];
                    locations_1 = [];
                    state.weatherLocations.forEach(function (loc) {
                        locations_1.push({
                            EntityId: loc.LocationId,
                            Name: loc.Name,
                            Latitude: loc.Latitude ? parseFloat(loc.Latitude) : 0,
                            Longitude: loc.Longitude ? parseFloat(loc.Longitude) : 0,
                        });
                    });
                    return [4 /*yield*/, getWeatherForecastService_1.default(locations_1, state.weatherUnit)];
                case 1:
                    weatherForecastResponse = _a.sent();
                    addWeatherDailyConditionsToStore(state.weatherDailyConditions, weatherForecastResponse);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=loadWeatherForecast.js.map

/***/ }),

/***/ 4819:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getWeatherForecastOperation_1 = __webpack_require__(4820);
var getWeatherForecastRequest_1 = __webpack_require__(4822);
var ServiceRequestUtils_1 = __webpack_require__(31);
function getWeatherForecastService(weatherLocationId, temperatureUnit) {
    return getWeatherForecastOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: getWeatherForecastRequest_1.default({
            WeatherLocationIds: weatherLocationId,
            TemperatureUnit: temperatureUnit,
        }),
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = getWeatherForecastService;
//# sourceMappingURL=getWeatherForecastService.js.map

/***/ }),

/***/ 4820:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var getWeatherForecastJsonRequest_1 = __webpack_require__(4821);
function getWeatherForecastOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = getWeatherForecastJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("GetWeatherForecast", req, options);
}
exports.default = getWeatherForecastOperation;


/***/ }),

/***/ 4821:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getWeatherForecastJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetWeatherForecastJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = getWeatherForecastJsonRequest;


/***/ }),

/***/ 4822:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function getWeatherForecastRequest(data) {
    var result = tslib_1.__assign({ __type: 'GetWeatherForecastRequest:#Exchange' }, data);
    return result;
}
exports.default = getWeatherForecastRequest;


/***/ }),

/***/ 4823:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var ReactDOM = __webpack_require__(71);
var UpNextExpansion_1 = __webpack_require__(4824);
var getWeatherImage_1 = __webpack_require__(3677);
var store_1 = __webpack_require__(2935);
var owa_common_strings_1 = __webpack_require__(37);
var toggleAgenda_1 = __webpack_require__(4827);
var toggleExpansion_1 = __webpack_require__(4828);
var ContextualMenu_1 = __webpack_require__(677);
var owa_strings_1 = __webpack_require__(20);
var owa_url_1 = __webpack_require__(216);
var react_1 = __webpack_require__(1546);
var owa_datetime_format_1 = __webpack_require__(600);
var Button_1 = __webpack_require__(62);
var styles = __webpack_require__(4829);
var classNames = __webpack_require__(30);
var MINUTE_IN_MILLISECONDS = 60 * 1000;
var FIVE_MINUTES_IN_MILLISECONDS = 5 * MINUTE_IN_MILLISECONDS;
var TWENTY_MINUTES_IN_MILLISECONDS = 20 * MINUTE_IN_MILLISECONDS;
var UpNext = /** @class */ (function (_super) {
    tslib_1.__extends(UpNext, _super);
    function UpNext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpNext.prototype.render = function () {
        var _this = this;
        var meetings = this.props.calendarItems.values();
        var agendaMeetings = [];
        var name;
        var location;
        var time;
        var isMeetingIn5MinRange;
        if (!meetings || meetings.length == 0) {
            name = owa_common_strings_1.default.noEvents;
        }
        else {
            var nextMeeting = void 0;
            var fiveMinutesAgo = this.getFiveMinutesAgoDate();
            for (var _i = 0, meetings_1 = meetings; _i < meetings_1.length; _i++) {
                var meeting = meetings_1[_i];
                agendaMeetings.push({
                    key: meeting.ItemId.Id,
                    name: owa_datetime_format_1.formatShortTime(new Date(meeting.Start)) +
                        ' - ' +
                        meeting.Subject +
                        ' ● ' +
                        meeting.Location.DisplayName,
                });
                if (!nextMeeting && new Date(meeting.Start) > fiveMinutesAgo) {
                    // We found the next meeting.
                    nextMeeting = meeting;
                }
            }
            // Grab the info out of the next meeting.
            if (nextMeeting) {
                name = nextMeeting.Subject;
                location = nextMeeting.Location.DisplayName;
                var now = new Date();
                var meetingStart = new Date(nextMeeting.Start);
                var isTodayMeeting = new Date().toDateString() == meetingStart.toDateString();
                var millisecondsDifference = now.getTime() - meetingStart.getTime();
                if (millisecondsDifference >= 0 &&
                    millisecondsDifference <= FIVE_MINUTES_IN_MILLISECONDS) {
                    time = owa_common_strings_1.default.now;
                }
                else if (millisecondsDifference < 0 &&
                    Math.abs(millisecondsDifference) <= TWENTY_MINUTES_IN_MILLISECONDS) {
                    var minutes = Math.ceil(Math.abs(millisecondsDifference) / MINUTE_IN_MILLISECONDS);
                    time = minutes <= 1 ? owa_common_strings_1.default.inOneMinute : owa_strings_1.format(owa_common_strings_1.default.inXMinutes, minutes);
                }
                else {
                    // Regular time.
                    time = owa_strings_1.format(isTodayMeeting ? owa_common_strings_1.default.todayAt : owa_common_strings_1.default.tomorrowAt, owa_datetime_format_1.formatShortTime(meetingStart));
                }
            }
            else {
                // No next meeting.
                name = owa_common_strings_1.default.noMoreEvents;
            }
        }
        agendaMeetings.push({
            key: 'agendaToCalendar',
            name: owa_common_strings_1.default.goToCalendar,
            icon: "Calendar" /* Calendar */,
            onClick: function () {
                return window.location.assign(owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/calendar' }));
            },
        });
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.container },
                this.renderWeatherCharms(),
                React.createElement("div", { className: styles.left },
                    React.createElement("span", { className: styles.next }, owa_common_strings_1.default.next),
                    React.createElement("span", { className: styles.name, title: name }, name),
                    React.createElement("span", { className: styles.location, title: location }, location)),
                React.createElement("div", { className: styles.right },
                    React.createElement("span", { className: classNames(isMeetingIn5MinRange && styles.important, styles.time) }, time),
                    React.createElement(Button_1.IconButton, { ref: function (ref) { return (_this.agendaRef = ReactDOM.findDOMNode(ref)); }, onClick: this.toggleAgendaClick, className: styles.agenda, iconProps: { iconName: "Calendar" /* Calendar */ } }),
                    store_1.default.isAgendaOpen && (React.createElement(ContextualMenu_1.ContextualMenu, { shouldFocusOnMount: true, isBeakVisible: true, target: this.agendaRef, gapSpace: 5, directionalHint: 11 /* rightTopEdge */, onDismiss: this.toggleAgendaClick, items: agendaMeetings })))),
            store_1.default.isExpansionOpen && React.createElement(UpNextExpansion_1.default, null)));
    };
    UpNext.prototype.renderWeatherCharms = function () {
        var weatherClasses = classNames(styles.weather, !this.props.isExpansionOpen && styles.withNoExpansion);
        return (this.props.weatherDailyConditions && (React.createElement("a", { className: weatherClasses, href: store_1.default.weatherClickThrough, onClick: this.toggleExpansionClick, target: "_blank" },
            React.createElement("div", { className: styles.weatherInnerContainer }, this.props.weatherDailyConditions.map(function (item, index) {
                var weatherCharmClasses = classNames(styles.weatherIcon, index == 0 ? styles.currentWeather : styles.forecastWeather, getWeatherImage_1.default(item.SkyCode), getWeatherImage_1.default()); // Fallback css image.
                return (React.createElement("i", { key: 'wi' + index, className: weatherCharmClasses, title: item.SkyText }));
            })))));
    };
    UpNext.prototype.toggleExpansionClick = function (ev) {
        toggleExpansion_1.default();
    };
    UpNext.prototype.toggleAgendaClick = function (ev) {
        ev.stopPropagation();
        toggleAgenda_1.default();
    };
    UpNext.prototype.getFiveMinutesAgoDate = function () {
        var fiveMinutesAgo = new Date();
        fiveMinutesAgo.setTime(fiveMinutesAgo.getTime() - FIVE_MINUTES_IN_MILLISECONDS);
        return fiveMinutesAgo;
    };
    UpNext = tslib_1.__decorate([
        react_1.reactive({
            calendarItems: function () { return store_1.default.calendarItems; },
            isAgendaOpen: function () { return store_1.default.isAgendaOpen; },
            isExpansionOpen: function () { return store_1.default.isExpansionOpen; },
            weatherClickThrough: function () { return store_1.default.weatherClickThrough; },
            weatherDailyConditions: function () { return store_1.default.weatherDailyConditions; },
        })
    ], UpNext);
    return UpNext;
}(React.Component));
exports.default = UpNext;
//# sourceMappingURL=UpNext.js.map

/***/ }),

/***/ 4824:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var getWeatherImage_1 = __webpack_require__(3677);
var store_1 = __webpack_require__(2935);
var owa_common_strings_1 = __webpack_require__(37);
var owa_strings_1 = __webpack_require__(20);
var react_1 = __webpack_require__(1546);
var Icon_1 = __webpack_require__(43);
var styles = __webpack_require__(4825);
var classNames = __webpack_require__(30);
var UpNextExpansion = /** @class */ (function (_super) {
    tslib_1.__extends(UpNextExpansion, _super);
    function UpNextExpansion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpNextExpansion.prototype.render = function () {
        var _this = this;
        return (this.props.weatherDailyConditions && (React.createElement("a", { className: styles.container, href: store_1.default.weatherClickThrough, target: "_blank" }, this.props.weatherDailyConditions.map(function (item, index) {
            if (index > 0) {
                // We do not care about the item at index 0 as it is the weather for
                // Now. From index 1 forward they will represent: today, tomorrow, etc.
                var precipitationChance = parseInt(item.PrecipitationChance);
                var weatherCharmClasses = classNames(!!precipitationChance && styles.withPrecipitation, getWeatherImage_1.default(item.SkyCode), getWeatherImage_1.default()); // Fallback css image.
                return (React.createElement("div", { className: styles.weather },
                    React.createElement("div", { className: styles.day }, _this.getDayShortName(index)),
                    React.createElement("div", { key: 'wi' + index, className: weatherCharmClasses, title: item.SkyText }, !!precipitationChance && (React.createElement("span", null,
                        React.createElement(Icon_1.Icon, { className: styles.drop, iconName: "Drop" /* Drop */ }),
                        owa_strings_1.format(owa_common_strings_1.default.percentage, precipitationChance)))),
                    React.createElement("div", { className: styles.high },
                        owa_strings_1.format(owa_common_strings_1.default.temperature, item.High),
                        React.createElement("span", { className: styles.low }, owa_strings_1.format(owa_common_strings_1.default.temperature, item.Low)))));
            }
            else {
                return null;
            }
        }))));
    };
    UpNextExpansion.prototype.getDayShortName = function (index) {
        var dayIndex = (new Date().getDay() + (index - 1)) % 7;
        switch (dayIndex) {
            case 0:
                return owa_common_strings_1.default.sundayShort;
            case 1:
                return owa_common_strings_1.default.mondayShort;
            case 2:
                return owa_common_strings_1.default.tuesdayShort;
            case 3:
                return owa_common_strings_1.default.wednesdayShort;
            case 4:
                return owa_common_strings_1.default.thursdayShort;
            case 5:
                return owa_common_strings_1.default.fridayShort;
            case 6:
                return owa_common_strings_1.default.saturdayShort;
        }
        // Unreachable point.
        return null;
    };
    UpNextExpansion = tslib_1.__decorate([
        react_1.reactive({
            weatherClickThrough: function () { return store_1.default.weatherClickThrough; },
            weatherDailyConditions: function () { return store_1.default.weatherDailyConditions; },
        })
    ], UpNextExpansion);
    return UpNextExpansion;
}(React.Component));
exports.default = UpNextExpansion;
//# sourceMappingURL=UpNextExpansion.js.map

/***/ }),

/***/ 4825:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4826);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4826:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._240lhWMcyjhPjbI9ehhUh3{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%;cursor:pointer;max-width:700px}._240lhWMcyjhPjbI9ehhUh3,._240lhWMcyjhPjbI9ehhUh3:active,._240lhWMcyjhPjbI9ehhUh3:hover,._240lhWMcyjhPjbI9ehhUh3:visited{color:\"[theme:neutralPrimary, default:#333333]\"}._1SiLJ8uCkW4c3Xxta2prqV{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1m960lBuvtRc-F1XCRziH,._3N5LN3VLYdC3coNZQfTH5N,._14GMWrzodxnHml6qEa_961,._19E9LHQHLcQ8NGsYT3-BRW,._240lhWMcyjhPjbI9ehhUh3{font-size:14px;font-weight:400;text-decoration:none}._1SiLJ8uCkW4c3Xxta2prqV,._1SiLJ8uCkW4c3Xxta2prqV:active,._1SiLJ8uCkW4c3Xxta2prqV:hover,._1SiLJ8uCkW4c3Xxta2prqV:visited{color:inherit}._1m960lBuvtRc-F1XCRziH{color:\"[theme:neutralPrimary, default:#333333]\"}html[dir=ltr] ._19E9LHQHLcQ8NGsYT3-BRW{margin-left:10px}html[dir=rtl] ._19E9LHQHLcQ8NGsYT3-BRW{margin-right:10px}._14GMWrzodxnHml6qEa_961,._19E9LHQHLcQ8NGsYT3-BRW{color:\"[theme:neutralTertiary, default:#a6a6a6]\"}html[dir=ltr] ._29e7Wl-BUlUAK8sZOfABT{margin-left:-50px}html[dir=rtl] ._29e7Wl-BUlUAK8sZOfABT{margin-right:-50px}._14GMWrzodxnHml6qEa_961{font-size:11px;font-weight:400;white-space:nowrap}html[dir=ltr] ._14GMWrzodxnHml6qEa_961{margin-left:30px}html[dir=rtl] ._14GMWrzodxnHml6qEa_961{margin-right:30px}", ""]);

// exports
exports.locals = {
	"container": "_240lhWMcyjhPjbI9ehhUh3",
	"weather": "_1SiLJ8uCkW4c3Xxta2prqV",
	"day": "_3N5LN3VLYdC3coNZQfTH5N",
	"high": "_1m960lBuvtRc-F1XCRziH",
	"drop": "_14GMWrzodxnHml6qEa_961",
	"low": "_19E9LHQHLcQ8NGsYT3-BRW",
	"withPrecipitation": "_29e7Wl-BUlUAK8sZOfABT"
};

/***/ }),

/***/ 4827:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2935);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('toggleAgenda')(legacy_1.select({
    store: function () { return store_1.default; },
})(function toggleAgenda(state) {
    state.store.isAgendaOpen = !state.store.isAgendaOpen;
}));
//# sourceMappingURL=toggleAgenda.js.map

/***/ }),

/***/ 4828:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(2935);
var legacy_1 = __webpack_require__(1);
exports.default = legacy_1.action('toggleExpansion')(legacy_1.select({
    store: function () { return store_1.default; },
})(function toggleExpansion(state) {
    state.store.isExpansionOpen = !state.store.isExpansionOpen;
}));
//# sourceMappingURL=toggleExpansion.js.map

/***/ }),

/***/ 4829:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(4830);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 4830:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._1Ct2gWqPjywPi0gsaCHqKI{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:30px;white-space:nowrap;overflow:hidden;font-size:12px;font-weight:400}._1-4EKm_FXKd35AxCfkbJAQ{color:\"[theme:themePrimary, default:#0078D7]\";font-weight:600}._1-4EKm_FXKd35AxCfkbJAQ:after{content:\":\"}._24GdUG7ngWWjj9QiXjoOMH{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow:hidden}._2JgTr9nRlj6TsTrapM-Og0,._24GdUG7ngWWjj9QiXjoOMH{display:-webkit-box;display:-ms-flexbox;display:flex}._2JgTr9nRlj6TsTrapM-Og0{-webkit-box-flex:0;-ms-flex:0;flex:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir=ltr] ._3i4Bb8dGKLfbDGFxEyiNkw,html[dir=ltr] .CorxfhM2Tu8vWCoRmVYXp,html[dir=ltr] .VaCd_VxjsTlhI_dRgQEBe{margin-left:5px}html[dir=rtl] ._3i4Bb8dGKLfbDGFxEyiNkw,html[dir=rtl] .CorxfhM2Tu8vWCoRmVYXp,html[dir=rtl] .VaCd_VxjsTlhI_dRgQEBe{margin-right:5px}._3i4Bb8dGKLfbDGFxEyiNkw,.VaCd_VxjsTlhI_dRgQEBe{color:\"[theme:neutralSecondary, default:#666666]\"}._3i4Bb8dGKLfbDGFxEyiNkw:not(:empty):before{content:\" \\2022   \"}._2Hf9BYP42hld5qqBfwU_vN{color:\"[theme:themePrimary, default:#0078D7]\";cursor:pointer;font-size:17px;font-weight:300}html[dir=ltr] ._2Hf9BYP42hld5qqBfwU_vN{margin-left:10px}html[dir=rtl] ._2Hf9BYP42hld5qqBfwU_vN{margin-right:10px}.FzgqzVX-vvYUKXNgky1J1{color:#e81123}._2tjyJo56jnFkMPfwjO2ow7{cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex}._2tjyJo56jnFkMPfwjO2ow7._3_af7OWqKXLRQW_RB_BzIz:hover{width:100%}._2tjyJo56jnFkMPfwjO2ow7._3_af7OWqKXLRQW_RB_BzIz:hover ._3lzCyF11JjUdstWRPDrtyP{display:inline-block}.P_7I7CWtmtxgypxKif5YD{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;max-width:500px;width:100%}html[dir=ltr] ._3s5zRU8lQKSu0EEQCblH0Y{margin-right:5px}html[dir=rtl] ._3s5zRU8lQKSu0EEQCblH0Y{margin-left:5px}._3lzCyF11JjUdstWRPDrtyP{display:none}", ""]);

// exports
exports.locals = {
	"container": "_1Ct2gWqPjywPi0gsaCHqKI",
	"next": "_1-4EKm_FXKd35AxCfkbJAQ",
	"left": "_24GdUG7ngWWjj9QiXjoOMH",
	"right": "_2JgTr9nRlj6TsTrapM-Og0",
	"name": "CorxfhM2Tu8vWCoRmVYXp",
	"time": "VaCd_VxjsTlhI_dRgQEBe",
	"location": "_3i4Bb8dGKLfbDGFxEyiNkw",
	"agenda": "_2Hf9BYP42hld5qqBfwU_vN",
	"important": "FzgqzVX-vvYUKXNgky1J1",
	"weather": "_2tjyJo56jnFkMPfwjO2ow7",
	"withNoExpansion": "_3_af7OWqKXLRQW_RB_BzIz",
	"forecastWeather": "_3lzCyF11JjUdstWRPDrtyP",
	"weatherInnerContainer": "P_7I7CWtmtxgypxKif5YD",
	"weatherIcon": "_3s5zRU8lQKSu0EEQCblH0Y"
};

/***/ })

});


// WEBPACK FOOTER //
// owa.UpNext.js